import { RootState } from "@/app/store";

export const SelectSiteState = (state: RootState) => state.sites
export const SelectIsLoading = (state: RootState) => SelectSiteState(state).loading
export const SelectSiteError = (state: RootState) => SelectSiteState(state).error
export const SelectSiteImages = (state: RootState) => SelectSiteState(state).images